class MobileMenuDrawer {
  constructor(container) {
    this.container = container;
    this.mobileMenuToggle = container.querySelector('.mobile-menu-toggle');
    this.mobileMenuDrawer = container.querySelector('#mobileMenuDrawer');
    this.mobileDropdownToggles = container.querySelectorAll('.mobile-menu-dropdown-toggle');
    this.header = document.querySelector('header');
    this.body = document.body;
    this.init();
  }

  init() {
    this.updateMobileMenuPosition();
    this.bindMobileMenuEvents();
  }

  updateMobileMenuPosition() {
    if (this.header) {
      const headerRect = this.header.getBoundingClientRect();
      document.documentElement.style.setProperty('--mobile-menu-top-position', `${headerRect.bottom}px`);
    }
  }

  bindMobileMenuEvents() {
    window.addEventListener('resize', () => this.updateMobileMenuPosition());
    window.addEventListener('scroll', () => this.updateMobileMenuPosition());
    this.mobileMenuToggle.addEventListener('click', () => this.toggleMobileDrawer());
    this.mobileDropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => this.toggleMobileSubmenu(e.currentTarget));
    });

    document.addEventListener('click', (event) => this.handleMobileOutsideClick(event));
  }

  toggleMobileDrawer() {
    this.updateMobileMenuPosition();

    const isExpanded = this.mobileMenuToggle.getAttribute('aria-expanded') === 'true';
    this.mobileMenuToggle.setAttribute('aria-expanded', !isExpanded);
    this.mobileMenuDrawer.classList.toggle('active');
    this.body.classList.toggle('overflow-hidden');
  }

  toggleMobileSubmenu(toggle) {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', !isExpanded);
    toggle.nextElementSibling.classList.toggle('active');
  }

  handleMobileOutsideClick(event) {
    if (this.mobileMenuDrawer.classList.contains('active') &&
        !this.mobileMenuDrawer.contains(event.target) &&
        !this.mobileMenuToggle.contains(event.target)) {
      this.mobileMenuToggle.setAttribute('aria-expanded', 'false');
      this.mobileMenuDrawer.classList.remove('active');
      this.body.classList.remove('overflow-hidden');
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const mobileMenuComponents = document.querySelectorAll('.header-drawer-component');
  mobileMenuComponents.forEach(container => {
    new MobileMenuDrawer(container);
  });
});